import React from 'react';
import { Link } from 'react-router-dom';

// Add hover effects styles
const styleSheet = document.createElement('style');
styleSheet.innerHTML = `
  .login-required-primary:hover {
    background: linear-gradient(135deg, #0056b3, #003d82) !important;
    box-shadow: 0 4px 16px rgba(0, 123, 255, 0.4) !important;
    transform: translateY(-2px);
  }
  
  .login-required-secondary:hover {
    color: #046a37 !important;
    text-decoration: underline !important;
  }
`;

if (!document.head.querySelector('[data-login-required-styles]')) {
  styleSheet.setAttribute('data-login-required-styles', 'true');
  document.head.appendChild(styleSheet);
}

export default function LoginRequiredNotice({ 
  title = "Bitte zuerst anmelden", 
  subtitle = "Melden Sie sich an, um Pläne zu kaufen und diese Seite zu verwenden." 
}) {
  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.iconWrapper}>
          <div style={styles.icon}>🔐</div>
        </div>
        
        <h2 style={styles.title}>{title}</h2>
        <p style={styles.subtitle}>{subtitle}</p>
        
        <div style={styles.buttonGroup}>
          <Link 
            to="/login" 
            style={styles.primaryButton}
            className="login-required-primary"
          >
            Anmelden
          </Link>
          <Link 
            to="/register" 
            style={styles.secondaryButton}
            className="login-required-secondary"
          >
            Konto erstellen
          </Link>
        </div>
      </div>
    </div>
  );
}

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '400px',
    padding: '2rem'
  },
  card: {
    background: '#fff',
    borderRadius: '20px',
    padding: '3rem 2.5rem',
    boxShadow: '0 15px 60px rgba(28, 58, 122, 0.15), 0 4px 20px rgba(5, 135, 68, 0.08)',
    textAlign: 'center',
    maxWidth: '450px',
    width: '100%'
  },
  iconWrapper: {
    marginBottom: '1.5rem'
  },
  icon: {
    fontSize: '3rem',
    marginBottom: '1rem'
  },
  title: {
    fontSize: '1.9rem',
    fontWeight: 800,
    color: '#1c3a7a',
    margin: '0 0 1rem 0',
    background: 'linear-gradient(135deg, #1c3a7a 0%, #058744 100%)',
    WebkitBackgroundClip: 'text',
    backgroundClip: 'text',
    color: 'transparent',
    letterSpacing: '-0.5px'
  },
  subtitle: {
    color: '#6c757d',
    fontSize: '1.1rem',
    margin: '0 0 2rem 0',
    fontWeight: 500,
    lineHeight: '1.5'
  },
  buttonGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    alignItems: 'center'
  },
  primaryButton: {
    display: 'inline-block',
    width: '100%',
    maxWidth: '200px',
    padding: '0.875rem 2rem',
    background: 'linear-gradient(135deg, #007BFF, #0056b3)',
    color: 'white',
    textDecoration: 'none',
    borderRadius: '12px',
    fontSize: '1.1rem',
    fontWeight: 600,
    textAlign: 'center',
    boxShadow: '0 2px 8px rgba(0, 123, 255, 0.3)',
    transition: 'all 0.3s ease'
  },
  secondaryButton: {
    color: '#058744',
    textDecoration: 'none',
    fontSize: '1rem',
    fontWeight: 600,
    padding: '0.5rem',
    transition: 'color 0.3s ease'
  }
};
